import {
  PlatformConstants,
} from '@quest/platform-murka/dist/PlatformConstants';

export class PlatformConstantsGame extends PlatformConstants {
    // code here
}
PlatformConstants.BASE_GAME_REELSET = 'paidSpin';
PlatformConstants.FREE_GAME_REELSET = 'freeSpin';


